import ReactGA from 'react-ga';

const sendPageview = (path: string) => {
  ReactGA.pageview(path, ['page-view']);
};

export default sendPageview;
